import { useContext } from 'react'

import { FloatingSelectContext } from '../../FloatingSelectContext'

export function useFloatingSelectContext() {
  const context = useContext(FloatingSelectContext)

  return { context }
}
